import React from "react"
import { Router } from "@reach/router"
import Homepage from "./homepage"
import Account from "./account/profile"
import Checkout from "./check"
import CheckoutSuccess from "./success"
import CheckoutPending from "./pending"
import CheckoutFail from "./fail"
import SEO from "../components/seo"
import EventUpdate from "./eventupdate"
import EventDetail from "./eventdetail"
import WishlistProduct from "./wishlistproduct"
import Product from "./product"

const IndexPage = () => {
  const homeMobileImgLink = `https://d3en5mej4c6rt8.cloudfront.net/banner/5f229cf29cea9402d562ce2c_mobilexb39v4n7qw.jpg`
  return (
    <>
      <SEO
        imageUrl={homeMobileImgLink}
        keywords="hardware, home improvements, garden, lawn, tools, automotive"
      />
      <Router>
        <Homepage path="/" />
        <Account path="/account/profile" />
        <Checkout path="/check" />
        <EventUpdate path="/eventupdate/:id" />
        <EventDetail path="/eventdetail/:id" />
        <WishlistProduct path="/wishlist/:wishlistid/product/:id" />
        <Product path="/product/:name_skuId" />
        <CheckoutSuccess path="/success" />
        <CheckoutPending path="/pending" />
        <CheckoutFail path="/fail" />
      </Router>
    </>
  )
}

export default IndexPage
